/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
/** Boolean expression to filter rows from the table "batch_change_request_reviews_job_runs". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestReviewsJobRunsBoolExp = {
  _and?: Array<BatchChangeRequestReviewsJobRunsBoolExp> | null | undefined;
  _not?: BatchChangeRequestReviewsJobRunsBoolExp | null | undefined;
  _or?: Array<BatchChangeRequestReviewsJobRunsBoolExp> | null | undefined;
  batchChangeRequestReviewsJob?: BatchChangeRequestReviewsJobsBoolExp | null | undefined;
  batchChangeRequestReviewsJobId?: UuidComparisonExp | null | undefined;
  comment?: StringComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  s3LogPath?: StringComparisonExp | null | undefined;
  statusId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "batch_change_request_reviews_jobs". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestReviewsJobsBoolExp = {
  _and?: Array<BatchChangeRequestReviewsJobsBoolExp> | null | undefined;
  _not?: BatchChangeRequestReviewsJobsBoolExp | null | undefined;
  _or?: Array<BatchChangeRequestReviewsJobsBoolExp> | null | undefined;
  batchChangeRequestReviewsJobRuns?: BatchChangeRequestReviewsJobRunsBoolExp | null | undefined;
  batchChangeRequestsJobId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  reviewTypeId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExp = {
  count?: BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "batch_change_requests_job_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestsJobRecordComposerDefinitionsBoolExp = {
  _and?: Array<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: BatchChangeRequestsJobRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp> | null | undefined;
  batchChangeRequestsJob?: BatchChangeRequestsJobsBoolExp | null | undefined;
  batchChangeRequestsJobId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn =
  /** column name */
  | 'batchChangeRequestsJobId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'recordComposerDefinitionId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "batch_change_requests_job_runs". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestsJobRunsBoolExp = {
  _and?: Array<BatchChangeRequestsJobRunsBoolExp> | null | undefined;
  _not?: BatchChangeRequestsJobRunsBoolExp | null | undefined;
  _or?: Array<BatchChangeRequestsJobRunsBoolExp> | null | undefined;
  batchChangeRequestsJob?: BatchChangeRequestsJobsBoolExp | null | undefined;
  batchChangeRequestsJobId?: UuidComparisonExp | null | undefined;
  changeRequests?: ChangeRequestsBoolExp | null | undefined;
  changeRequestsAggregate?: ChangeRequestsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  mappingLog?: JsonbComparisonExp | null | undefined;
  s3LogPath?: StringComparisonExp | null | undefined;
  statusId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** order by aggregate values of table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: BatchChangeRequestsJobsMaxOrderBy | null | undefined;
  min?: BatchChangeRequestsJobsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "batch_change_requests_jobs". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestsJobsBoolExp = {
  _and?: Array<BatchChangeRequestsJobsBoolExp> | null | undefined;
  _not?: BatchChangeRequestsJobsBoolExp | null | undefined;
  _or?: Array<BatchChangeRequestsJobsBoolExp> | null | undefined;
  batchChangeRequestReviewsJobs?: BatchChangeRequestReviewsJobsBoolExp | null | undefined;
  batchChangeRequestsJobRecordComposerDefinitions?: BatchChangeRequestsJobRecordComposerDefinitionsBoolExp | null | undefined;
  batchChangeRequestsJobRecordComposerDefinitionsAggregate?: BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExp | null | undefined;
  batchChangeRequestsJobRuns?: BatchChangeRequestsJobRunsBoolExp | null | undefined;
  changeRequests?: ChangeRequestsBoolExp | null | undefined;
  changeRequestsAggregate?: ChangeRequestsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  evidenceSet?: EvidenceSetsBoolExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  jobTypeId?: StringComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  s3Path?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  jobTypeId?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  s3Path?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  jobTypeId?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  s3Path?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by aggregate values of table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: BatchEvidencesJobRunsMaxOrderBy | null | undefined;
  min?: BatchEvidencesJobRunsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "batch_evidences_job_runs". All fields are combined with a logical 'AND'. */
export type BatchEvidencesJobRunsBoolExp = {
  _and?: Array<BatchEvidencesJobRunsBoolExp> | null | undefined;
  _not?: BatchEvidencesJobRunsBoolExp | null | undefined;
  _or?: Array<BatchEvidencesJobRunsBoolExp> | null | undefined;
  batchEvidencesJob?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  evidences?: EvidencesBoolExp | null | undefined;
  evidencesAggregate?: EvidencesAggregateBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  jobResult?: JsonbComparisonExp | null | undefined;
  mappingLog?: JsonbComparisonExp | null | undefined;
  outputMode?: StringComparisonExp | null | undefined;
  s3LogPath?: StringComparisonExp | null | undefined;
  statusId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** order by max() on columns of table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsMaxOrderBy = {
  batchEvidencesJobId?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  outputMode?: OrderBy | null | undefined;
  s3LogPath?: OrderBy | null | undefined;
  statusId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsMinOrderBy = {
  batchEvidencesJobId?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  outputMode?: OrderBy | null | undefined;
  s3LogPath?: OrderBy | null | undefined;
  statusId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** Ordering options when selecting data from "batch_evidences_job_runs". */
export type BatchEvidencesJobRunsOrderBy = {
  batchEvidencesJob?: BatchEvidencesJobsOrderBy | null | undefined;
  batchEvidencesJobId?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  evidencesAggregate?: EvidencesAggregateOrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  jobResult?: OrderBy | null | undefined;
  mappingLog?: OrderBy | null | undefined;
  outputMode?: OrderBy | null | undefined;
  s3LogPath?: OrderBy | null | undefined;
  statusId?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  user?: UsersOrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

export type BatchEvidencesJobsAggregateBoolExp = {
  count?: BatchEvidencesJobsAggregateBoolExpCount | null | undefined;
};

/** order by aggregate values of table "batch_evidences_jobs" */
export type BatchEvidencesJobsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: BatchEvidencesJobsMaxOrderBy | null | undefined;
  min?: BatchEvidencesJobsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "batch_evidences_jobs". All fields are combined with a logical 'AND'. */
export type BatchEvidencesJobsBoolExp = {
  _and?: Array<BatchEvidencesJobsBoolExp> | null | undefined;
  _not?: BatchEvidencesJobsBoolExp | null | undefined;
  _or?: Array<BatchEvidencesJobsBoolExp> | null | undefined;
  batchEvidencesJobRuns?: BatchEvidencesJobRunsBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  evidenceImporter?: EvidenceImportersBoolExp | null | undefined;
  evidenceImporterId?: UuidComparisonExp | null | undefined;
  evidenceSet?: EvidenceSetsBoolExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  evidences?: EvidencesBoolExp | null | undefined;
  evidencesAggregate?: EvidencesAggregateBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  jobTypeId?: StringComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  s3Path?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  unifiedEvidenceDrafts?: UnifiedEvidenceDraftsBoolExp | null | undefined;
  unifiedEvidenceDraftsAggregate?: UnifiedEvidenceDraftsAggregateBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "batch_evidences_jobs" */
export type BatchEvidencesJobsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidenceImporterId?: OrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  jobTypeId?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  s3Path?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "batch_evidences_jobs" */
export type BatchEvidencesJobsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidenceImporterId?: OrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  jobTypeId?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  s3Path?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Ordering options when selecting data from "batch_evidences_jobs". */
export type BatchEvidencesJobsOrderBy = {
  batchEvidencesJobRunsAggregate?: BatchEvidencesJobRunsAggregateOrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  dataImportProject?: DataImportProjectsOrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  dataSource?: DataSourcesOrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidenceImporter?: EvidenceImportersOrderBy | null | undefined;
  evidenceImporterId?: OrderBy | null | undefined;
  evidenceSet?: EvidenceSetsOrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  evidencesAggregate?: EvidencesAggregateOrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  jobTypeId?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  s3Path?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  unifiedEvidenceDraftsAggregate?: UnifiedEvidenceDraftsAggregateOrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** select columns of table "batch_evidences_jobs" */
export type BatchEvidencesJobsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dataImportProjectId'
  /** column name */
  | 'dataSourceId'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'evidenceImporterId'
  /** column name */
  | 'evidenceSetId'
  /** column name */
  | 'id'
  /** column name */
  | 'jobTypeId'
  /** column name */
  | 'name'
  /** column name */
  | 's3Path'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: boolean | null | undefined;
  _gt?: boolean | null | undefined;
  _gte?: boolean | null | undefined;
  _in?: Array<boolean> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: boolean | null | undefined;
  _lte?: boolean | null | undefined;
  _neq?: boolean | null | undefined;
  _nin?: Array<boolean> | null | undefined;
};

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type CategoriesBoolExp = {
  _and?: Array<CategoriesBoolExp> | null | undefined;
  _not?: CategoriesBoolExp | null | undefined;
  _or?: Array<CategoriesBoolExp> | null | undefined;
  categoryPath?: CategoryPathsBoolExp | null | undefined;
  categoryPropertySchemaSet?: CategoryPropertySchemaSetsBoolExp | null | undefined;
  categoryType?: CategoryTypesBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  documentUrl?: StringComparisonExp | null | undefined;
  i18nLabel?: JsonbComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  recordMetadataCategories?: RecordMetadataCategoriesBoolExp | null | undefined;
  relationType?: RelationTypesBoolExp | null | undefined;
  relationTypeId?: UuidComparisonExp | null | undefined;
  sourceRelationTypes?: RelationTypesBoolExp | null | undefined;
  targetRelationTypes?: RelationTypesBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  typeId?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "category_paths". All fields are combined with a logical 'AND'. */
export type CategoryPathsBoolExp = {
  _and?: Array<CategoryPathsBoolExp> | null | undefined;
  _not?: CategoryPathsBoolExp | null | undefined;
  _or?: Array<CategoryPathsBoolExp> | null | undefined;
  category?: CategoriesBoolExp | null | undefined;
  categoryId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  path?: LtreeComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "category_property_schema_sets". All fields are combined with a logical 'AND'. */
export type CategoryPropertySchemaSetsBoolExp = {
  _and?: Array<CategoryPropertySchemaSetsBoolExp> | null | undefined;
  _not?: CategoryPropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<CategoryPropertySchemaSetsBoolExp> | null | undefined;
  category?: CategoriesBoolExp | null | undefined;
  categoryId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "category_types". All fields are combined with a logical 'AND'. */
export type CategoryTypesBoolExp = {
  _and?: Array<CategoryTypesBoolExp> | null | undefined;
  _not?: CategoryTypesBoolExp | null | undefined;
  _or?: Array<CategoryTypesBoolExp> | null | undefined;
  categories?: CategoriesBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_commits". All fields are combined with a logical 'AND'. */
export type ChangeRequestCommitsBoolExp = {
  _and?: Array<ChangeRequestCommitsBoolExp> | null | undefined;
  _not?: ChangeRequestCommitsBoolExp | null | undefined;
  _or?: Array<ChangeRequestCommitsBoolExp> | null | undefined;
  changeRequest?: ChangeRequestsBoolExp | null | undefined;
  changeRequestId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  items?: ChangeRequestItemCommitsBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_item_commits". All fields are combined with a logical 'AND'. */
export type ChangeRequestItemCommitsBoolExp = {
  _and?: Array<ChangeRequestItemCommitsBoolExp> | null | undefined;
  _not?: ChangeRequestItemCommitsBoolExp | null | undefined;
  _or?: Array<ChangeRequestItemCommitsBoolExp> | null | undefined;
  changeRequestCommit?: ChangeRequestCommitsBoolExp | null | undefined;
  changeRequestCommitId?: UuidComparisonExp | null | undefined;
  changeRequestItem?: ChangeRequestItemsBoolExp | null | undefined;
  changeRequestItemId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_item_record_metadata". All fields are combined with a logical 'AND'. */
export type ChangeRequestItemRecordMetadataBoolExp = {
  _and?: Array<ChangeRequestItemRecordMetadataBoolExp> | null | undefined;
  _not?: ChangeRequestItemRecordMetadataBoolExp | null | undefined;
  _or?: Array<ChangeRequestItemRecordMetadataBoolExp> | null | undefined;
  changeRequestItem?: ChangeRequestItemsBoolExp | null | undefined;
  changeRequestItemId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  recordMetadata?: RecordMetadataBoolExp | null | undefined;
  recordMetadataId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_item_records". All fields are combined with a logical 'AND'. */
export type ChangeRequestItemRecordsBoolExp = {
  _and?: Array<ChangeRequestItemRecordsBoolExp> | null | undefined;
  _not?: ChangeRequestItemRecordsBoolExp | null | undefined;
  _or?: Array<ChangeRequestItemRecordsBoolExp> | null | undefined;
  changeRequestItem?: ChangeRequestItemsBoolExp | null | undefined;
  changeRequestItemId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  record?: RecordsBoolExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type ChangeRequestItemsAggregateBoolExp = {
  count?: ChangeRequestItemsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_items". All fields are combined with a logical 'AND'. */
export type ChangeRequestItemsBoolExp = {
  _and?: Array<ChangeRequestItemsBoolExp> | null | undefined;
  _not?: ChangeRequestItemsBoolExp | null | undefined;
  _or?: Array<ChangeRequestItemsBoolExp> | null | undefined;
  changeRequest?: ChangeRequestsBoolExp | null | undefined;
  changeRequestId?: UuidComparisonExp | null | undefined;
  changeRequestItemRecord?: ChangeRequestItemRecordsBoolExp | null | undefined;
  changeRequestItemRecordMetadata?: ChangeRequestItemRecordMetadataBoolExp | null | undefined;
  commit?: ChangeRequestItemCommitsBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  modelType?: StringComparisonExp | null | undefined;
  operationType?: StringComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "change_request_items" */
export type ChangeRequestItemsSelectColumn =
  /** column name */
  | 'changeRequestId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'modelType'
  /** column name */
  | 'operationType'
  /** column name */
  | 'properties'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

export type ChangeRequestRecordComposerDefinitionsAggregateBoolExp = {
  count?: ChangeRequestRecordComposerDefinitionsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type ChangeRequestRecordComposerDefinitionsBoolExp = {
  _and?: Array<ChangeRequestRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: ChangeRequestRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<ChangeRequestRecordComposerDefinitionsBoolExp> | null | undefined;
  changeRequest?: ChangeRequestsBoolExp | null | undefined;
  changeRequestId?: UuidComparisonExp | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsSelectColumn =
  /** column name */
  | 'changeRequestId'
  /** column name */
  | 'recordComposerDefinitionId'
  /** column name */
  | 'tenantId';

/** Boolean expression to filter rows from the table "change_request_review_types". All fields are combined with a logical 'AND'. */
export type ChangeRequestReviewTypesBoolExp = {
  _and?: Array<ChangeRequestReviewTypesBoolExp> | null | undefined;
  _not?: ChangeRequestReviewTypesBoolExp | null | undefined;
  _or?: Array<ChangeRequestReviewTypesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type ChangeRequestReviewsAggregateBoolExp = {
  count?: ChangeRequestReviewsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "change_request_reviews". All fields are combined with a logical 'AND'. */
export type ChangeRequestReviewsBoolExp = {
  _and?: Array<ChangeRequestReviewsBoolExp> | null | undefined;
  _not?: ChangeRequestReviewsBoolExp | null | undefined;
  _or?: Array<ChangeRequestReviewsBoolExp> | null | undefined;
  batchChangeRequestReviewsJobRunId?: UuidComparisonExp | null | undefined;
  changeRequest?: ChangeRequestsBoolExp | null | undefined;
  changeRequestId?: UuidComparisonExp | null | undefined;
  comment?: StringComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  type?: ChangeRequestReviewTypesBoolExp | null | undefined;
  typeId?: StringComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "change_request_reviews" */
export type ChangeRequestReviewsSelectColumn =
  /** column name */
  | 'batchChangeRequestReviewsJobRunId'
  /** column name */
  | 'changeRequestId'
  /** column name */
  | 'comment'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'typeId'
  /** column name */
  | 'userId';

/** Boolean expression to filter rows from the table "change_request_statuses". All fields are combined with a logical 'AND'. */
export type ChangeRequestStatusesBoolExp = {
  _and?: Array<ChangeRequestStatusesBoolExp> | null | undefined;
  _not?: ChangeRequestStatusesBoolExp | null | undefined;
  _or?: Array<ChangeRequestStatusesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type ChangeRequestsAggregateBoolExp = {
  count?: ChangeRequestsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "change_requests". All fields are combined with a logical 'AND'. */
export type ChangeRequestsBoolExp = {
  _and?: Array<ChangeRequestsBoolExp> | null | undefined;
  _not?: ChangeRequestsBoolExp | null | undefined;
  _or?: Array<ChangeRequestsBoolExp> | null | undefined;
  batchChangeRequestsJob?: BatchChangeRequestsJobsBoolExp | null | undefined;
  batchChangeRequestsJobId?: UuidComparisonExp | null | undefined;
  batchChangeRequestsJobRun?: BatchChangeRequestsJobRunsBoolExp | null | undefined;
  batchChangeRequestsJobRunId?: UuidComparisonExp | null | undefined;
  changeRequestRecordComposerDefinition?: ChangeRequestRecordComposerDefinitionsBoolExp | null | undefined;
  commit?: ChangeRequestCommitsBoolExp | null | undefined;
  composerKey?: StringComparisonExp | null | undefined;
  context?: JsonbComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  evidenceChangeRequests?: EvidenceChangeRequestsBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  items?: ChangeRequestItemsBoolExp | null | undefined;
  itemsAggregate?: ChangeRequestItemsAggregateBoolExp | null | undefined;
  reviews?: ChangeRequestReviewsBoolExp | null | undefined;
  reviewsAggregate?: ChangeRequestReviewsAggregateBoolExp | null | undefined;
  status?: ChangeRequestStatusesBoolExp | null | undefined;
  statusId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** select columns of table "change_requests" */
export type ChangeRequestsSelectColumn =
  /** column name */
  | 'batchChangeRequestsJobId'
  /** column name */
  | 'batchChangeRequestsJobRunId'
  /** column name */
  | 'composerKey'
  /** column name */
  | 'context'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'statusId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId';

/** Boolean expression to filter rows from the table "data_import_project_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type DataImportProjectRecordComposerDefinitionsBoolExp = {
  _and?: Array<DataImportProjectRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: DataImportProjectRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<DataImportProjectRecordComposerDefinitionsBoolExp> | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** order by aggregate values of table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: DataImportProjectStatusLogsMaxOrderBy | null | undefined;
  min?: DataImportProjectStatusLogsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_import_project_status_logs". All fields are combined with a logical 'AND'. */
export type DataImportProjectStatusLogsBoolExp = {
  _and?: Array<DataImportProjectStatusLogsBoolExp> | null | undefined;
  _not?: DataImportProjectStatusLogsBoolExp | null | undefined;
  _or?: Array<DataImportProjectStatusLogsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  dataImportProjectStatus?: DataImportProjectStatusesBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  statusId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  statusId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  statusId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_import_project_statuses". All fields are combined with a logical 'AND'. */
export type DataImportProjectStatusesBoolExp = {
  _and?: Array<DataImportProjectStatusesBoolExp> | null | undefined;
  _not?: DataImportProjectStatusesBoolExp | null | undefined;
  _or?: Array<DataImportProjectStatusesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "data_import_project_statuses". */
export type DataImportProjectStatusesOrderBy = {
  createdAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by aggregate values of table "data_import_project_users" */
export type DataImportProjectUsersAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: DataImportProjectUsersMaxOrderBy | null | undefined;
  min?: DataImportProjectUsersMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_import_project_users". All fields are combined with a logical 'AND'. */
export type DataImportProjectUsersBoolExp = {
  _and?: Array<DataImportProjectUsersBoolExp> | null | undefined;
  _not?: DataImportProjectUsersBoolExp | null | undefined;
  _or?: Array<DataImportProjectUsersBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** order by max() on columns of table "data_import_project_users" */
export type DataImportProjectUsersMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "data_import_project_users" */
export type DataImportProjectUsersMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_import_projects". All fields are combined with a logical 'AND'. */
export type DataImportProjectsBoolExp = {
  _and?: Array<DataImportProjectsBoolExp> | null | undefined;
  _not?: DataImportProjectsBoolExp | null | undefined;
  _or?: Array<DataImportProjectsBoolExp> | null | undefined;
  batchChangeRequestsJobs?: BatchChangeRequestsJobsBoolExp | null | undefined;
  batchEvidencesJobs?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobsAggregate?: BatchEvidencesJobsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProjectStatus?: DataImportProjectStatusesBoolExp | null | undefined;
  dataImportProjectStatusLogs?: DataImportProjectStatusLogsBoolExp | null | undefined;
  dataImportProjectUsers?: DataImportProjectUsersBoolExp | null | undefined;
  dataSourceImportProjects?: DataSourceImportProjectsBoolExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  documentUrl?: StringComparisonExp | null | undefined;
  endDate?: TimestamptzComparisonExp | null | undefined;
  evidenceSetImportProjects?: EvidenceSetImportProjectsBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  seq?: IntComparisonExp | null | undefined;
  startDate?: TimestamptzComparisonExp | null | undefined;
  statusId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "data_import_projects". */
export type DataImportProjectsOrderBy = {
  batchChangeRequestsJobsAggregate?: BatchChangeRequestsJobsAggregateOrderBy | null | undefined;
  batchEvidencesJobsAggregate?: BatchEvidencesJobsAggregateOrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  dataImportProjectStatus?: DataImportProjectStatusesOrderBy | null | undefined;
  dataImportProjectStatusLogsAggregate?: DataImportProjectStatusLogsAggregateOrderBy | null | undefined;
  dataImportProjectUsersAggregate?: DataImportProjectUsersAggregateOrderBy | null | undefined;
  dataSourceImportProjectsAggregate?: DataSourceImportProjectsAggregateOrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  description?: OrderBy | null | undefined;
  documentUrl?: OrderBy | null | undefined;
  endDate?: OrderBy | null | undefined;
  evidenceSetImportProjectsAggregate?: EvidenceSetImportProjectsAggregateOrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  seq?: OrderBy | null | undefined;
  startDate?: OrderBy | null | undefined;
  statusId?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_gsheets". All fields are combined with a logical 'AND'. */
export type DataSourceGsheetsBoolExp = {
  _and?: Array<DataSourceGsheetsBoolExp> | null | undefined;
  _not?: DataSourceGsheetsBoolExp | null | undefined;
  _or?: Array<DataSourceGsheetsBoolExp> | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  googleAppsScriptId?: StringComparisonExp | null | undefined;
  googleSheetId?: IntComparisonExp | null | undefined;
  googleSpreadsheetId?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "data_source_gsheets". */
export type DataSourceGsheetsOrderBy = {
  dataSource?: DataSourcesOrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  googleAppsScriptId?: OrderBy | null | undefined;
  googleSheetId?: OrderBy | null | undefined;
  googleSpreadsheetId?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_import_project_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type DataSourceImportProjectRecordComposerDefinitionsBoolExp = {
  _and?: Array<DataSourceImportProjectRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: DataSourceImportProjectRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<DataSourceImportProjectRecordComposerDefinitionsBoolExp> | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  dataSourceImportProject?: DataSourceImportProjectsBoolExp | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** order by aggregate values of table "data_source_import_projects" */
export type DataSourceImportProjectsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: DataSourceImportProjectsMaxOrderBy | null | undefined;
  min?: DataSourceImportProjectsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_import_projects". All fields are combined with a logical 'AND'. */
export type DataSourceImportProjectsBoolExp = {
  _and?: Array<DataSourceImportProjectsBoolExp> | null | undefined;
  _not?: DataSourceImportProjectsBoolExp | null | undefined;
  _or?: Array<DataSourceImportProjectsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "data_source_import_projects" */
export type DataSourceImportProjectsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "data_source_import_projects" */
export type DataSourceImportProjectsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_jsons". All fields are combined with a logical 'AND'. */
export type DataSourceJsonsBoolExp = {
  _and?: Array<DataSourceJsonsBoolExp> | null | undefined;
  _not?: DataSourceJsonsBoolExp | null | undefined;
  _or?: Array<DataSourceJsonsBoolExp> | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  s3Path?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "data_source_jsons". */
export type DataSourceJsonsOrderBy = {
  dataSource?: DataSourcesOrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  s3Path?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
};

/** order by aggregate values of table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: DataSourcePropertySchemaSetsMaxOrderBy | null | undefined;
  min?: DataSourcePropertySchemaSetsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_property_schema_sets". All fields are combined with a logical 'AND'. */
export type DataSourcePropertySchemaSetsBoolExp = {
  _and?: Array<DataSourcePropertySchemaSetsBoolExp> | null | undefined;
  _not?: DataSourcePropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<DataSourcePropertySchemaSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  propertySchemaSetId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  propertySchemaSetId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by aggregate values of table "data_source_references" */
export type DataSourceReferencesAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: DataSourceReferencesMaxOrderBy | null | undefined;
  min?: DataSourceReferencesMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_references". All fields are combined with a logical 'AND'. */
export type DataSourceReferencesBoolExp = {
  _and?: Array<DataSourceReferencesBoolExp> | null | undefined;
  _not?: DataSourceReferencesBoolExp | null | undefined;
  _or?: Array<DataSourceReferencesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  reference?: ReferencesBoolExp | null | undefined;
  referenceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "data_source_references" */
export type DataSourceReferencesMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "data_source_references" */
export type DataSourceReferencesMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by aggregate values of table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: DataSourceTemplatePropertySchemaSetsMaxOrderBy | null | undefined;
  min?: DataSourceTemplatePropertySchemaSetsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_template_property_schema_sets". All fields are combined with a logical 'AND'. */
export type DataSourceTemplatePropertySchemaSetsBoolExp = {
  _and?: Array<DataSourceTemplatePropertySchemaSetsBoolExp> | null | undefined;
  _not?: DataSourceTemplatePropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<DataSourceTemplatePropertySchemaSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSourceTemplate?: DataSourceTemplatesBoolExp | null | undefined;
  dataSourceTemplateId?: UuidComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataSourceTemplateId?: OrderBy | null | undefined;
  propertySchemaSetId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataSourceTemplateId?: OrderBy | null | undefined;
  propertySchemaSetId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Ordering options when selecting data from "data_source_template_property_schema_sets". */
export type DataSourceTemplatePropertySchemaSetsOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataSourceTemplate?: DataSourceTemplatesOrderBy | null | undefined;
  dataSourceTemplateId?: OrderBy | null | undefined;
  propertySchemaSet?: PropertySchemaSetsOrderBy | null | undefined;
  propertySchemaSetId?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_source_templates". All fields are combined with a logical 'AND'. */
export type DataSourceTemplatesBoolExp = {
  _and?: Array<DataSourceTemplatesBoolExp> | null | undefined;
  _not?: DataSourceTemplatesBoolExp | null | undefined;
  _or?: Array<DataSourceTemplatesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSourceTemplatePropertySchemaSet?: DataSourceTemplatePropertySchemaSetsBoolExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "data_source_templates". */
export type DataSourceTemplatesOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataSourceTemplatePropertySchemaSetAggregate?: DataSourceTemplatePropertySchemaSetsAggregateOrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "data_sources". All fields are combined with a logical 'AND'. */
export type DataSourcesBoolExp = {
  _and?: Array<DataSourcesBoolExp> | null | undefined;
  _not?: DataSourcesBoolExp | null | undefined;
  _or?: Array<DataSourcesBoolExp> | null | undefined;
  batchEvidencesJobs?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobsAggregate?: BatchEvidencesJobsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSourceGSheets?: DataSourceGsheetsBoolExp | null | undefined;
  dataSourceImportProjects?: DataSourceImportProjectsBoolExp | null | undefined;
  dataSourceJson?: DataSourceJsonsBoolExp | null | undefined;
  dataSourcePropertySchemaSet?: DataSourcePropertySchemaSetsBoolExp | null | undefined;
  dataSourceReferences?: DataSourceReferencesBoolExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "data_sources". */
export type DataSourcesOrderBy = {
  batchEvidencesJobsAggregate?: BatchEvidencesJobsAggregateOrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  dataSourceGSheets?: DataSourceGsheetsOrderBy | null | undefined;
  dataSourceImportProjectsAggregate?: DataSourceImportProjectsAggregateOrderBy | null | undefined;
  dataSourceJson?: DataSourceJsonsOrderBy | null | undefined;
  dataSourcePropertySchemaSetAggregate?: DataSourcePropertySchemaSetsAggregateOrderBy | null | undefined;
  dataSourceReferencesAggregate?: DataSourceReferencesAggregateOrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  description?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "entity_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type EntityRecordComposerDefinitionsBoolExp = {
  _and?: Array<EntityRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: EntityRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<EntityRecordComposerDefinitionsBoolExp> | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "entity_records". All fields are combined with a logical 'AND'. */
export type EntityRecordsBoolExp = {
  _and?: Array<EntityRecordsBoolExp> | null | undefined;
  _not?: EntityRecordsBoolExp | null | undefined;
  _or?: Array<EntityRecordsBoolExp> | null | undefined;
  record?: RecordsBoolExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  sourceRecordEdges?: SourceRecordEdgesBoolExp | null | undefined;
  targetRecordEdges?: TargetRecordEdgesBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** order by aggregate values of table "evidence_change_requests" */
export type EvidenceChangeRequestsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: EvidenceChangeRequestsMaxOrderBy | null | undefined;
  min?: EvidenceChangeRequestsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_change_requests". All fields are combined with a logical 'AND'. */
export type EvidenceChangeRequestsBoolExp = {
  _and?: Array<EvidenceChangeRequestsBoolExp> | null | undefined;
  _not?: EvidenceChangeRequestsBoolExp | null | undefined;
  _or?: Array<EvidenceChangeRequestsBoolExp> | null | undefined;
  changeRequest?: ChangeRequestsBoolExp | null | undefined;
  changeRequestId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  evidence?: EvidencesBoolExp | null | undefined;
  evidenceId?: UuidComparisonExp | null | undefined;
  evidenceVersion?: EvidenceVersionsBoolExp | null | undefined;
  evidenceVersionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "evidence_change_requests" */
export type EvidenceChangeRequestsMaxOrderBy = {
  changeRequestId?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  evidenceId?: OrderBy | null | undefined;
  evidenceVersionId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "evidence_change_requests" */
export type EvidenceChangeRequestsMinOrderBy = {
  changeRequestId?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  evidenceId?: OrderBy | null | undefined;
  evidenceVersionId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

export type EvidenceEvidenceSetsAggregateBoolExp = {
  count?: EvidenceEvidenceSetsAggregateBoolExpCount | null | undefined;
};

/** order by aggregate values of table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: EvidenceEvidenceSetsMaxOrderBy | null | undefined;
  min?: EvidenceEvidenceSetsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_evidence_sets". All fields are combined with a logical 'AND'. */
export type EvidenceEvidenceSetsBoolExp = {
  _and?: Array<EvidenceEvidenceSetsBoolExp> | null | undefined;
  _not?: EvidenceEvidenceSetsBoolExp | null | undefined;
  _or?: Array<EvidenceEvidenceSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  evidence?: EvidencesBoolExp | null | undefined;
  evidenceId?: UuidComparisonExp | null | undefined;
  evidenceSet?: EvidenceSetsBoolExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  evidenceId?: OrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  evidenceId?: OrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** select columns of table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'evidenceId'
  /** column name */
  | 'evidenceSetId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "evidence_importers". All fields are combined with a logical 'AND'. */
export type EvidenceImportersBoolExp = {
  _and?: Array<EvidenceImportersBoolExp> | null | undefined;
  _not?: EvidenceImportersBoolExp | null | undefined;
  _or?: Array<EvidenceImportersBoolExp> | null | undefined;
  batchEvidencesJobs?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobsAggregate?: BatchEvidencesJobsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  dataSource?: DataSourcesBoolExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  definition?: JsonbComparisonExp | null | undefined;
  evidences?: EvidencesBoolExp | null | undefined;
  evidencesAggregate?: EvidencesAggregateBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "evidence_importers". */
export type EvidenceImportersOrderBy = {
  batchEvidencesJobsAggregate?: BatchEvidencesJobsAggregateOrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  dataImportProject?: DataImportProjectsOrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  dataSource?: DataSourcesOrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  definition?: OrderBy | null | undefined;
  evidencesAggregate?: EvidencesAggregateOrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by aggregate values of table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: EvidenceRecordGeoItemsMaxOrderBy | null | undefined;
  min?: EvidenceRecordGeoItemsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_record_geo_items". All fields are combined with a logical 'AND'. */
export type EvidenceRecordGeoItemsBoolExp = {
  _and?: Array<EvidenceRecordGeoItemsBoolExp> | null | undefined;
  _not?: EvidenceRecordGeoItemsBoolExp | null | undefined;
  _or?: Array<EvidenceRecordGeoItemsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  evidence?: EvidencesBoolExp | null | undefined;
  evidenceId?: UuidComparisonExp | null | undefined;
  evidenceVersion?: EvidenceVersionsBoolExp | null | undefined;
  evidenceVersionId?: UuidComparisonExp | null | undefined;
  geoItemId?: UuidComparisonExp | null | undefined;
  recordGeoItem?: RecordGeoItemsBoolExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  evidenceId?: OrderBy | null | undefined;
  evidenceVersionId?: OrderBy | null | undefined;
  geoItemId?: OrderBy | null | undefined;
  recordId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  evidenceId?: OrderBy | null | undefined;
  evidenceVersionId?: OrderBy | null | undefined;
  geoItemId?: OrderBy | null | undefined;
  recordId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by aggregate values of table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: EvidenceSetImportProjectsMaxOrderBy | null | undefined;
  min?: EvidenceSetImportProjectsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_set_import_projects". All fields are combined with a logical 'AND'. */
export type EvidenceSetImportProjectsBoolExp = {
  _and?: Array<EvidenceSetImportProjectsBoolExp> | null | undefined;
  _not?: EvidenceSetImportProjectsBoolExp | null | undefined;
  _or?: Array<EvidenceSetImportProjectsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProject?: DataImportProjectsBoolExp | null | undefined;
  dataImportProjectId?: UuidComparisonExp | null | undefined;
  evidenceSet?: EvidenceSetsBoolExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  dataImportProjectId?: OrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_set_property_schema_sets". All fields are combined with a logical 'AND'. */
export type EvidenceSetPropertySchemaSetsBoolExp = {
  _and?: Array<EvidenceSetPropertySchemaSetsBoolExp> | null | undefined;
  _not?: EvidenceSetPropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<EvidenceSetPropertySchemaSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  evidenceSet?: EvidenceSetsBoolExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "evidence_set_property_schema_sets". */
export type EvidenceSetPropertySchemaSetsOrderBy = {
  createdAt?: OrderBy | null | undefined;
  evidenceSet?: EvidenceSetsOrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  propertySchemaSet?: PropertySchemaSetsOrderBy | null | undefined;
  propertySchemaSetId?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_sets". All fields are combined with a logical 'AND'. */
export type EvidenceSetsBoolExp = {
  _and?: Array<EvidenceSetsBoolExp> | null | undefined;
  _not?: EvidenceSetsBoolExp | null | undefined;
  _or?: Array<EvidenceSetsBoolExp> | null | undefined;
  batchChangeRequestsJobs?: BatchChangeRequestsJobsBoolExp | null | undefined;
  batchEvidencesJobs?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobsAggregate?: BatchEvidencesJobsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  evidenceEvidenceSets?: EvidenceEvidenceSetsBoolExp | null | undefined;
  evidenceEvidenceSetsAggregate?: EvidenceEvidenceSetsAggregateBoolExp | null | undefined;
  evidenceSetImportProjects?: EvidenceSetImportProjectsBoolExp | null | undefined;
  evidenceSetPropertySchemaSet?: EvidenceSetPropertySchemaSetsBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  recordComposerDefinitionEvidenceSets?: RecordComposerDefinitionEvidenceSetsBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "evidence_sets". */
export type EvidenceSetsOrderBy = {
  batchChangeRequestsJobsAggregate?: BatchChangeRequestsJobsAggregateOrderBy | null | undefined;
  batchEvidencesJobsAggregate?: BatchEvidencesJobsAggregateOrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  description?: OrderBy | null | undefined;
  evidenceEvidenceSetsAggregate?: EvidenceEvidenceSetsAggregateOrderBy | null | undefined;
  evidenceSetImportProjectsAggregate?: EvidenceSetImportProjectsAggregateOrderBy | null | undefined;
  evidenceSetPropertySchemaSet?: EvidenceSetPropertySchemaSetsOrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  recordComposerDefinitionEvidenceSetsAggregate?: RecordComposerDefinitionEvidenceSetsAggregateOrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by aggregate values of table "evidence_versions" */
export type EvidenceVersionsAggregateOrderBy = {
  avg?: EvidenceVersionsAvgOrderBy | null | undefined;
  count?: OrderBy | null | undefined;
  max?: EvidenceVersionsMaxOrderBy | null | undefined;
  min?: EvidenceVersionsMinOrderBy | null | undefined;
  stddev?: EvidenceVersionsStddevOrderBy | null | undefined;
  stddevPop?: EvidenceVersionsStddevPopOrderBy | null | undefined;
  stddevSamp?: EvidenceVersionsStddevSampOrderBy | null | undefined;
  sum?: EvidenceVersionsSumOrderBy | null | undefined;
  varPop?: EvidenceVersionsVarPopOrderBy | null | undefined;
  varSamp?: EvidenceVersionsVarSampOrderBy | null | undefined;
  variance?: EvidenceVersionsVarianceOrderBy | null | undefined;
};

/** order by avg() on columns of table "evidence_versions" */
export type EvidenceVersionsAvgOrderBy = {
  version?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "evidence_versions". All fields are combined with a logical 'AND'. */
export type EvidenceVersionsBoolExp = {
  _and?: Array<EvidenceVersionsBoolExp> | null | undefined;
  _not?: EvidenceVersionsBoolExp | null | undefined;
  _or?: Array<EvidenceVersionsBoolExp> | null | undefined;
  batchEvidencesJobId?: UuidComparisonExp | null | undefined;
  caller?: StringComparisonExp | null | undefined;
  citation?: JsonbComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  evidence?: EvidencesBoolExp | null | undefined;
  evidenceChangeRequests?: EvidenceChangeRequestsBoolExp | null | undefined;
  evidenceId?: UuidComparisonExp | null | undefined;
  evidenceImporterId?: UuidComparisonExp | null | undefined;
  evidenceSetIdArray?: UuidArrayComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  jobRunId?: UuidComparisonExp | null | undefined;
  metadata?: JsonbComparisonExp | null | undefined;
  operation?: StringComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  referenceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
  version?: IntComparisonExp | null | undefined;
  wikipediaJson?: JsonbComparisonExp | null | undefined;
};

/** order by max() on columns of table "evidence_versions" */
export type EvidenceVersionsMaxOrderBy = {
  batchEvidencesJobId?: OrderBy | null | undefined;
  caller?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidenceId?: OrderBy | null | undefined;
  evidenceImporterId?: OrderBy | null | undefined;
  evidenceSetIdArray?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  jobRunId?: OrderBy | null | undefined;
  operation?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
  version?: OrderBy | null | undefined;
};

/** order by min() on columns of table "evidence_versions" */
export type EvidenceVersionsMinOrderBy = {
  batchEvidencesJobId?: OrderBy | null | undefined;
  caller?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidenceId?: OrderBy | null | undefined;
  evidenceImporterId?: OrderBy | null | undefined;
  evidenceSetIdArray?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  jobRunId?: OrderBy | null | undefined;
  operation?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
  version?: OrderBy | null | undefined;
};

/** Ordering options when selecting data from "evidence_versions". */
export type EvidenceVersionsOrderBy = {
  batchEvidencesJobId?: OrderBy | null | undefined;
  caller?: OrderBy | null | undefined;
  citation?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidence?: EvidencesOrderBy | null | undefined;
  evidenceChangeRequestsAggregate?: EvidenceChangeRequestsAggregateOrderBy | null | undefined;
  evidenceId?: OrderBy | null | undefined;
  evidenceImporterId?: OrderBy | null | undefined;
  evidenceSetIdArray?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  jobRunId?: OrderBy | null | undefined;
  metadata?: OrderBy | null | undefined;
  operation?: OrderBy | null | undefined;
  properties?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
  version?: OrderBy | null | undefined;
  wikipediaJson?: OrderBy | null | undefined;
};

/** order by stddev() on columns of table "evidence_versions" */
export type EvidenceVersionsStddevOrderBy = {
  version?: OrderBy | null | undefined;
};

/** order by stddevPop() on columns of table "evidence_versions" */
export type EvidenceVersionsStddevPopOrderBy = {
  version?: OrderBy | null | undefined;
};

/** order by stddevSamp() on columns of table "evidence_versions" */
export type EvidenceVersionsStddevSampOrderBy = {
  version?: OrderBy | null | undefined;
};

/** order by sum() on columns of table "evidence_versions" */
export type EvidenceVersionsSumOrderBy = {
  version?: OrderBy | null | undefined;
};

/** order by varPop() on columns of table "evidence_versions" */
export type EvidenceVersionsVarPopOrderBy = {
  version?: OrderBy | null | undefined;
};

/** order by varSamp() on columns of table "evidence_versions" */
export type EvidenceVersionsVarSampOrderBy = {
  version?: OrderBy | null | undefined;
};

/** order by variance() on columns of table "evidence_versions" */
export type EvidenceVersionsVarianceOrderBy = {
  version?: OrderBy | null | undefined;
};

export type EvidencesAggregateBoolExp = {
  count?: EvidencesAggregateBoolExpCount | null | undefined;
};

/** order by aggregate values of table "evidences" */
export type EvidencesAggregateOrderBy = {
  avg?: EvidencesAvgOrderBy | null | undefined;
  count?: OrderBy | null | undefined;
  max?: EvidencesMaxOrderBy | null | undefined;
  min?: EvidencesMinOrderBy | null | undefined;
  stddev?: EvidencesStddevOrderBy | null | undefined;
  stddevPop?: EvidencesStddevPopOrderBy | null | undefined;
  stddevSamp?: EvidencesStddevSampOrderBy | null | undefined;
  sum?: EvidencesSumOrderBy | null | undefined;
  varPop?: EvidencesVarPopOrderBy | null | undefined;
  varSamp?: EvidencesVarSampOrderBy | null | undefined;
  variance?: EvidencesVarianceOrderBy | null | undefined;
};

/** order by avg() on columns of table "evidences" */
export type EvidencesAvgOrderBy = {
  version?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "evidences". All fields are combined with a logical 'AND'. */
export type EvidencesBoolExp = {
  _and?: Array<EvidencesBoolExp> | null | undefined;
  _not?: EvidencesBoolExp | null | undefined;
  _or?: Array<EvidencesBoolExp> | null | undefined;
  batchEvidencesJob?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobId?: UuidComparisonExp | null | undefined;
  batchEvidencesJobRun?: BatchEvidencesJobRunsBoolExp | null | undefined;
  batchEvidencesJobRunId?: UuidComparisonExp | null | undefined;
  citation?: JsonbComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  evidenceChangeRequests?: EvidenceChangeRequestsBoolExp | null | undefined;
  evidenceEvidenceSets?: EvidenceEvidenceSetsBoolExp | null | undefined;
  evidenceEvidenceSetsAggregate?: EvidenceEvidenceSetsAggregateBoolExp | null | undefined;
  evidenceImporter?: EvidenceImportersBoolExp | null | undefined;
  evidenceImporterId?: UuidComparisonExp | null | undefined;
  evidenceRecordGeoItems?: EvidenceRecordGeoItemsBoolExp | null | undefined;
  evidenceVersions?: EvidenceVersionsBoolExp | null | undefined;
  headVersion?: EvidenceVersionsBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  metadata?: JsonbComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  reference?: ReferencesBoolExp | null | undefined;
  referenceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
  version?: IntComparisonExp | null | undefined;
  wikipediaJson?: JsonbComparisonExp | null | undefined;
};

/** order by max() on columns of table "evidences" */
export type EvidencesMaxOrderBy = {
  batchEvidencesJobId?: OrderBy | null | undefined;
  batchEvidencesJobRunId?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidenceImporterId?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
  version?: OrderBy | null | undefined;
};

/** order by min() on columns of table "evidences" */
export type EvidencesMinOrderBy = {
  batchEvidencesJobId?: OrderBy | null | undefined;
  batchEvidencesJobRunId?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidenceImporterId?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
  version?: OrderBy | null | undefined;
};

/** Ordering options when selecting data from "evidences". */
export type EvidencesOrderBy = {
  batchEvidencesJob?: BatchEvidencesJobsOrderBy | null | undefined;
  batchEvidencesJobId?: OrderBy | null | undefined;
  batchEvidencesJobRun?: BatchEvidencesJobRunsOrderBy | null | undefined;
  batchEvidencesJobRunId?: OrderBy | null | undefined;
  citation?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidenceChangeRequestsAggregate?: EvidenceChangeRequestsAggregateOrderBy | null | undefined;
  evidenceEvidenceSetsAggregate?: EvidenceEvidenceSetsAggregateOrderBy | null | undefined;
  evidenceImporter?: EvidenceImportersOrderBy | null | undefined;
  evidenceImporterId?: OrderBy | null | undefined;
  evidenceRecordGeoItemsAggregate?: EvidenceRecordGeoItemsAggregateOrderBy | null | undefined;
  evidenceVersionsAggregate?: EvidenceVersionsAggregateOrderBy | null | undefined;
  headVersion?: EvidenceVersionsOrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  metadata?: OrderBy | null | undefined;
  properties?: OrderBy | null | undefined;
  reference?: ReferencesOrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  user?: UsersOrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
  version?: OrderBy | null | undefined;
  wikipediaJson?: OrderBy | null | undefined;
};

/** select columns of table "evidences" */
export type EvidencesSelectColumn =
  /** column name */
  | 'batchEvidencesJobId'
  /** column name */
  | 'batchEvidencesJobRunId'
  /** column name */
  | 'citation'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'evidenceImporterId'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'properties'
  /** column name */
  | 'referenceId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'version'
  /** column name */
  | 'wikipediaJson';

/** order by stddev() on columns of table "evidences" */
export type EvidencesStddevOrderBy = {
  version?: OrderBy | null | undefined;
};

/** order by stddevPop() on columns of table "evidences" */
export type EvidencesStddevPopOrderBy = {
  version?: OrderBy | null | undefined;
};

/** order by stddevSamp() on columns of table "evidences" */
export type EvidencesStddevSampOrderBy = {
  version?: OrderBy | null | undefined;
};

/** order by sum() on columns of table "evidences" */
export type EvidencesSumOrderBy = {
  version?: OrderBy | null | undefined;
};

/** order by varPop() on columns of table "evidences" */
export type EvidencesVarPopOrderBy = {
  version?: OrderBy | null | undefined;
};

/** order by varSamp() on columns of table "evidences" */
export type EvidencesVarSampOrderBy = {
  version?: OrderBy | null | undefined;
};

/** order by variance() on columns of table "evidences" */
export type EvidencesVarianceOrderBy = {
  version?: OrderBy | null | undefined;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: number | null | undefined;
  _gt?: number | null | undefined;
  _gte?: number | null | undefined;
  _in?: Array<number> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: number | null | undefined;
  _lte?: number | null | undefined;
  _neq?: number | null | undefined;
  _nin?: Array<number> | null | undefined;
};

export type JsonbCastExp = {
  String?: StringComparisonExp | null | undefined;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: JsonbCastExp | null | undefined;
  /** is the column contained in the given json value */
  _containedIn?: Types.JsonObject | null | undefined;
  /** does the column contain the given json value at the top level */
  _contains?: Types.JsonObject | null | undefined;
  _eq?: Types.JsonObject | null | undefined;
  _gt?: Types.JsonObject | null | undefined;
  _gte?: Types.JsonObject | null | undefined;
  /** does the string exist as a top-level key in the column */
  _hasKey?: string | null | undefined;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: Array<string> | null | undefined;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: Array<string> | null | undefined;
  _in?: Array<Types.JsonObject> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: Types.JsonObject | null | undefined;
  _lte?: Types.JsonObject | null | undefined;
  _neq?: Types.JsonObject | null | undefined;
  _nin?: Array<Types.JsonObject> | null | undefined;
};

/** Boolean expression to compare columns of type "ltree". All fields are combined with logical 'AND'. */
export type LtreeComparisonExp = {
  /** is the left argument an ancestor of right (or equal)? */
  _ancestor?: string | null | undefined;
  /** does array contain an ancestor of `ltree`? */
  _ancestorAny?: Array<string> | null | undefined;
  /** is the left argument a descendant of right (or equal)? */
  _descendant?: string | null | undefined;
  /** does array contain a descendant of `ltree`? */
  _descendantAny?: Array<string> | null | undefined;
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  /** does `ltree` match `lquery`? */
  _matches?: unknown;
  /** does `ltree` match any `lquery` in array? */
  _matchesAny?: Array<string> | null | undefined;
  /** does `ltree` match `ltxtquery`? */
  _matchesFulltext?: unknown;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

/** column ordering options */
export type OrderBy =
  /** in ascending order, nulls last */
  | 'ASC'
  /** in ascending order, nulls first */
  | 'ASC_NULLS_FIRST'
  /** in ascending order, nulls last */
  | 'ASC_NULLS_LAST'
  /** in descending order, nulls first */
  | 'DESC'
  /** in descending order, nulls first */
  | 'DESC_NULLS_FIRST'
  /** in descending order, nulls last */
  | 'DESC_NULLS_LAST';

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type OrganizationsBoolExp = {
  _and?: Array<OrganizationsBoolExp> | null | undefined;
  _not?: OrganizationsBoolExp | null | undefined;
  _or?: Array<OrganizationsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  kind?: StringComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  shortCode?: StringComparisonExp | null | undefined;
  tenants?: TenantsBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "organizations". */
export type OrganizationsOrderBy = {
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  kind?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  shortCode?: OrderBy | null | undefined;
  tenantsAggregate?: TenantsAggregateOrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "product_roles". All fields are combined with a logical 'AND'. */
export type ProductRolesBoolExp = {
  _and?: Array<ProductRolesBoolExp> | null | undefined;
  _not?: ProductRolesBoolExp | null | undefined;
  _or?: Array<ProductRolesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  product?: ProductsBoolExp | null | undefined;
  productId?: UuidComparisonExp | null | undefined;
  role?: RolesBoolExp | null | undefined;
  roleId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type ProductsBoolExp = {
  _and?: Array<ProductsBoolExp> | null | undefined;
  _not?: ProductsBoolExp | null | undefined;
  _or?: Array<ProductsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  importDirectWebhookUrl?: StringComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  originHosts?: StringComparisonExp | null | undefined;
  productRoles?: ProductRolesBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userProductRoles?: UserProductRolesBoolExp | null | undefined;
};

/** order by aggregate values of table "property_schema_associations" */
export type PropertySchemaAssociationsAggregateOrderBy = {
  avg?: PropertySchemaAssociationsAvgOrderBy | null | undefined;
  count?: OrderBy | null | undefined;
  max?: PropertySchemaAssociationsMaxOrderBy | null | undefined;
  min?: PropertySchemaAssociationsMinOrderBy | null | undefined;
  stddev?: PropertySchemaAssociationsStddevOrderBy | null | undefined;
  stddevPop?: PropertySchemaAssociationsStddevPopOrderBy | null | undefined;
  stddevSamp?: PropertySchemaAssociationsStddevSampOrderBy | null | undefined;
  sum?: PropertySchemaAssociationsSumOrderBy | null | undefined;
  varPop?: PropertySchemaAssociationsVarPopOrderBy | null | undefined;
  varSamp?: PropertySchemaAssociationsVarSampOrderBy | null | undefined;
  variance?: PropertySchemaAssociationsVarianceOrderBy | null | undefined;
};

/** order by avg() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsAvgOrderBy = {
  position?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "property_schema_associations". All fields are combined with a logical 'AND'. */
export type PropertySchemaAssociationsBoolExp = {
  _and?: Array<PropertySchemaAssociationsBoolExp> | null | undefined;
  _not?: PropertySchemaAssociationsBoolExp | null | undefined;
  _or?: Array<PropertySchemaAssociationsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  position?: IntComparisonExp | null | undefined;
  propertyAttributeTypeId?: StringComparisonExp | null | undefined;
  propertySchema?: PropertySchemasBoolExp | null | undefined;
  propertySchemaId?: UuidComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  required?: BooleanComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  unique?: BooleanComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  description?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  position?: OrderBy | null | undefined;
  propertyAttributeTypeId?: OrderBy | null | undefined;
  propertySchemaId?: OrderBy | null | undefined;
  propertySchemaSetId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  description?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  position?: OrderBy | null | undefined;
  propertyAttributeTypeId?: OrderBy | null | undefined;
  propertySchemaId?: OrderBy | null | undefined;
  propertySchemaSetId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by stddev() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsStddevOrderBy = {
  position?: OrderBy | null | undefined;
};

/** order by stddevPop() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsStddevPopOrderBy = {
  position?: OrderBy | null | undefined;
};

/** order by stddevSamp() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsStddevSampOrderBy = {
  position?: OrderBy | null | undefined;
};

/** order by sum() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsSumOrderBy = {
  position?: OrderBy | null | undefined;
};

/** order by varPop() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsVarPopOrderBy = {
  position?: OrderBy | null | undefined;
};

/** order by varSamp() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsVarSampOrderBy = {
  position?: OrderBy | null | undefined;
};

/** order by variance() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsVarianceOrderBy = {
  position?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "property_schema_sets". All fields are combined with a logical 'AND'. */
export type PropertySchemaSetsBoolExp = {
  _and?: Array<PropertySchemaSetsBoolExp> | null | undefined;
  _not?: PropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<PropertySchemaSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  propertySchemaAssociations?: PropertySchemaAssociationsBoolExp | null | undefined;
  propertySchemaSet?: DataSourceTemplatePropertySchemaSetsBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "property_schema_sets". */
export type PropertySchemaSetsOrderBy = {
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  propertySchemaAssociationsAggregate?: PropertySchemaAssociationsAggregateOrderBy | null | undefined;
  propertySchemaSet?: DataSourceTemplatePropertySchemaSetsOrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "property_schemas". All fields are combined with a logical 'AND'. */
export type PropertySchemasBoolExp = {
  _and?: Array<PropertySchemasBoolExp> | null | undefined;
  _not?: PropertySchemasBoolExp | null | undefined;
  _or?: Array<PropertySchemasBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  i18nLabel?: JsonbComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  propertySchemaAssociation?: PropertySchemaAssociationsBoolExp | null | undefined;
  propertyTypeId?: StringComparisonExp | null | undefined;
  propertyValueDagId?: UuidComparisonExp | null | undefined;
  propertyValueLinkFilterId?: UuidComparisonExp | null | undefined;
  selectOptions?: JsonbComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  urlAllowList?: JsonbComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "publishers". All fields are combined with a logical 'AND'. */
export type PublishersBoolExp = {
  _and?: Array<PublishersBoolExp> | null | undefined;
  _not?: PublishersBoolExp | null | undefined;
  _or?: Array<PublishersBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  referencePublishers?: ReferencePublishersBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by aggregate values of table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: RecordComposerDefinitionEvidenceSetsMaxOrderBy | null | undefined;
  min?: RecordComposerDefinitionEvidenceSetsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "record_composer_definition_evidence_sets". All fields are combined with a logical 'AND'. */
export type RecordComposerDefinitionEvidenceSetsBoolExp = {
  _and?: Array<RecordComposerDefinitionEvidenceSetsBoolExp> | null | undefined;
  _not?: RecordComposerDefinitionEvidenceSetsBoolExp | null | undefined;
  _or?: Array<RecordComposerDefinitionEvidenceSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  evidenceSet?: EvidenceSetsBoolExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** order by max() on columns of table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  recordComposerDefinitionId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  recordComposerDefinitionId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "record_composer_definition_property_schema_sets". All fields are combined with a logical 'AND'. */
export type RecordComposerDefinitionPropertySchemaSetsBoolExp = {
  _and?: Array<RecordComposerDefinitionPropertySchemaSetsBoolExp> | null | undefined;
  _not?: RecordComposerDefinitionPropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<RecordComposerDefinitionPropertySchemaSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "record_composer_definitions". All fields are combined with a logical 'AND'. */
export type RecordComposerDefinitionsBoolExp = {
  _and?: Array<RecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: RecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<RecordComposerDefinitionsBoolExp> | null | undefined;
  batchChangeRequestsJobRecordComposerDefinitions?: BatchChangeRequestsJobRecordComposerDefinitionsBoolExp | null | undefined;
  batchChangeRequestsJobRecordComposerDefinitionsAggregate?: BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExp | null | undefined;
  changeRequestRecordComposerDefinitions?: ChangeRequestRecordComposerDefinitionsBoolExp | null | undefined;
  changeRequestRecordComposerDefinitionsAggregate?: ChangeRequestRecordComposerDefinitionsAggregateBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataImportProjectRecordComposerDefinition?: DataImportProjectRecordComposerDefinitionsBoolExp | null | undefined;
  dataSourceImportProjectRecordComposerDefinition?: DataSourceImportProjectRecordComposerDefinitionsBoolExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  definition?: JsonbComparisonExp | null | undefined;
  entityComposerDefinition?: EntityRecordComposerDefinitionsBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  recordComposerDefinitionEvidenceSets?: RecordComposerDefinitionEvidenceSetsBoolExp | null | undefined;
  recordComposerDefinitionPropertySchemaSet?: RecordComposerDefinitionPropertySchemaSetsBoolExp | null | undefined;
  recordUpdateComposerDefinition?: RecordUpdateRecordComposerDefinitionsBoolExp | null | undefined;
  relationComposerDefinition?: RelationRecordComposerDefinitionsBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type RecordGeoItemsAggregateBoolExp = {
  count?: RecordGeoItemsAggregateBoolExpCount | null | undefined;
};

/** Boolean expression to filter rows from the table "record_geo_items". All fields are combined with a logical 'AND'. */
export type RecordGeoItemsBoolExp = {
  _and?: Array<RecordGeoItemsBoolExp> | null | undefined;
  _not?: RecordGeoItemsBoolExp | null | undefined;
  _or?: Array<RecordGeoItemsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  date?: StringComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  endDate?: StringComparisonExp | null | undefined;
  evidenceRecordGeoItems?: EvidenceRecordGeoItemsBoolExp | null | undefined;
  geoItemId?: UuidComparisonExp | null | undefined;
  i18nLabel?: JsonbComparisonExp | null | undefined;
  metadata?: JsonbComparisonExp | null | undefined;
  record?: RecordsBoolExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** select columns of table "record_geo_items" */
export type RecordGeoItemsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'date'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'endDate'
  /** column name */
  | 'geoItemId'
  /** column name */
  | 'i18nLabel'
  /** column name */
  | 'metadata'
  /** column name */
  | 'recordId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt';

/** Boolean expression to filter rows from the table "record_metadata". All fields are combined with a logical 'AND'. */
export type RecordMetadataBoolExp = {
  _and?: Array<RecordMetadataBoolExp> | null | undefined;
  _not?: RecordMetadataBoolExp | null | undefined;
  _or?: Array<RecordMetadataBoolExp> | null | undefined;
  changeRequestItemRecordMetadata?: ChangeRequestItemRecordMetadataBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  data?: JsonbComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  evidenceLineageIdentity?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  record?: RecordsBoolExp | null | undefined;
  recordDeactivatedAt?: TimestamptzComparisonExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  recordMetadataCategories?: RecordMetadataCategoriesBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  version?: IntComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "record_metadata_categories". All fields are combined with a logical 'AND'. */
export type RecordMetadataCategoriesBoolExp = {
  _and?: Array<RecordMetadataCategoriesBoolExp> | null | undefined;
  _not?: RecordMetadataCategoriesBoolExp | null | undefined;
  _or?: Array<RecordMetadataCategoriesBoolExp> | null | undefined;
  category?: CategoriesBoolExp | null | undefined;
  categoryId?: UuidComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  recordMetadata?: RecordMetadataBoolExp | null | undefined;
  recordMetadataId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "record_property_schema_sets". All fields are combined with a logical 'AND'. */
export type RecordPropertySchemaSetsBoolExp = {
  _and?: Array<RecordPropertySchemaSetsBoolExp> | null | undefined;
  _not?: RecordPropertySchemaSetsBoolExp | null | undefined;
  _or?: Array<RecordPropertySchemaSetsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  propertySchemaSet?: PropertySchemaSetsBoolExp | null | undefined;
  propertySchemaSetId?: UuidComparisonExp | null | undefined;
  record?: RecordsBoolExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "record_update_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type RecordUpdateRecordComposerDefinitionsBoolExp = {
  _and?: Array<RecordUpdateRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: RecordUpdateRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<RecordUpdateRecordComposerDefinitionsBoolExp> | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "records". All fields are combined with a logical 'AND'. */
export type RecordsBoolExp = {
  _and?: Array<RecordsBoolExp> | null | undefined;
  _not?: RecordsBoolExp | null | undefined;
  _or?: Array<RecordsBoolExp> | null | undefined;
  changeRequestItemRecords?: ChangeRequestItemRecordsBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  date?: StringComparisonExp | null | undefined;
  dateJdn?: IntComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  endDate?: StringComparisonExp | null | undefined;
  endDateJdn?: IntComparisonExp | null | undefined;
  entityRecord?: EntityRecordsBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  nameJa?: StringComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  recordGeoItems?: RecordGeoItemsBoolExp | null | undefined;
  recordGeoItemsAggregate?: RecordGeoItemsAggregateBoolExp | null | undefined;
  recordMetadata?: RecordMetadataBoolExp | null | undefined;
  recordMetadataId?: UuidComparisonExp | null | undefined;
  recordPropertySchemaSets?: RecordPropertySchemaSetsBoolExp | null | undefined;
  relationRecord?: RelationRecordsBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  version?: IntComparisonExp | null | undefined;
};

/** order by aggregate values of table "reference_files" */
export type ReferenceFilesAggregateOrderBy = {
  avg?: ReferenceFilesAvgOrderBy | null | undefined;
  count?: OrderBy | null | undefined;
  max?: ReferenceFilesMaxOrderBy | null | undefined;
  min?: ReferenceFilesMinOrderBy | null | undefined;
  stddev?: ReferenceFilesStddevOrderBy | null | undefined;
  stddevPop?: ReferenceFilesStddevPopOrderBy | null | undefined;
  stddevSamp?: ReferenceFilesStddevSampOrderBy | null | undefined;
  sum?: ReferenceFilesSumOrderBy | null | undefined;
  varPop?: ReferenceFilesVarPopOrderBy | null | undefined;
  varSamp?: ReferenceFilesVarSampOrderBy | null | undefined;
  variance?: ReferenceFilesVarianceOrderBy | null | undefined;
};

/** order by avg() on columns of table "reference_files" */
export type ReferenceFilesAvgOrderBy = {
  folioOffset?: OrderBy | null | undefined;
  numPages?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "reference_files". All fields are combined with a logical 'AND'. */
export type ReferenceFilesBoolExp = {
  _and?: Array<ReferenceFilesBoolExp> | null | undefined;
  _not?: ReferenceFilesBoolExp | null | undefined;
  _or?: Array<ReferenceFilesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  folioOffset?: IntComparisonExp | null | undefined;
  googleDriveFileId?: StringComparisonExp | null | undefined;
  googleDriveFileVersion?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  imagesCreatedAt?: TimestamptzComparisonExp | null | undefined;
  imagesS3UriPrefix?: StringComparisonExp | null | undefined;
  latest?: BooleanComparisonExp | null | undefined;
  mimeType?: StringComparisonExp | null | undefined;
  numPages?: IntComparisonExp | null | undefined;
  originalFileS3Uri?: StringComparisonExp | null | undefined;
  originalFileUploadedAt?: TimestamptzComparisonExp | null | undefined;
  reference?: ReferencesBoolExp | null | undefined;
  referenceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** order by max() on columns of table "reference_files" */
export type ReferenceFilesMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  folioOffset?: OrderBy | null | undefined;
  googleDriveFileId?: OrderBy | null | undefined;
  googleDriveFileVersion?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  imagesCreatedAt?: OrderBy | null | undefined;
  imagesS3UriPrefix?: OrderBy | null | undefined;
  mimeType?: OrderBy | null | undefined;
  numPages?: OrderBy | null | undefined;
  originalFileS3Uri?: OrderBy | null | undefined;
  originalFileUploadedAt?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "reference_files" */
export type ReferenceFilesMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  folioOffset?: OrderBy | null | undefined;
  googleDriveFileId?: OrderBy | null | undefined;
  googleDriveFileVersion?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  imagesCreatedAt?: OrderBy | null | undefined;
  imagesS3UriPrefix?: OrderBy | null | undefined;
  mimeType?: OrderBy | null | undefined;
  numPages?: OrderBy | null | undefined;
  originalFileS3Uri?: OrderBy | null | undefined;
  originalFileUploadedAt?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by stddev() on columns of table "reference_files" */
export type ReferenceFilesStddevOrderBy = {
  folioOffset?: OrderBy | null | undefined;
  numPages?: OrderBy | null | undefined;
};

/** order by stddevPop() on columns of table "reference_files" */
export type ReferenceFilesStddevPopOrderBy = {
  folioOffset?: OrderBy | null | undefined;
  numPages?: OrderBy | null | undefined;
};

/** order by stddevSamp() on columns of table "reference_files" */
export type ReferenceFilesStddevSampOrderBy = {
  folioOffset?: OrderBy | null | undefined;
  numPages?: OrderBy | null | undefined;
};

/** order by sum() on columns of table "reference_files" */
export type ReferenceFilesSumOrderBy = {
  folioOffset?: OrderBy | null | undefined;
  numPages?: OrderBy | null | undefined;
};

/** order by varPop() on columns of table "reference_files" */
export type ReferenceFilesVarPopOrderBy = {
  folioOffset?: OrderBy | null | undefined;
  numPages?: OrderBy | null | undefined;
};

/** order by varSamp() on columns of table "reference_files" */
export type ReferenceFilesVarSampOrderBy = {
  folioOffset?: OrderBy | null | undefined;
  numPages?: OrderBy | null | undefined;
};

/** order by variance() on columns of table "reference_files" */
export type ReferenceFilesVarianceOrderBy = {
  folioOffset?: OrderBy | null | undefined;
  numPages?: OrderBy | null | undefined;
};

/** order by aggregate values of table "reference_publishers" */
export type ReferencePublishersAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: ReferencePublishersMaxOrderBy | null | undefined;
  min?: ReferencePublishersMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "reference_publishers". All fields are combined with a logical 'AND'. */
export type ReferencePublishersBoolExp = {
  _and?: Array<ReferencePublishersBoolExp> | null | undefined;
  _not?: ReferencePublishersBoolExp | null | undefined;
  _or?: Array<ReferencePublishersBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  publisher?: PublishersBoolExp | null | undefined;
  publisherId?: UuidComparisonExp | null | undefined;
  reference?: ReferencesBoolExp | null | undefined;
  referenceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** order by max() on columns of table "reference_publishers" */
export type ReferencePublishersMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  publisherId?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "reference_publishers" */
export type ReferencePublishersMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  publisherId?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "references". All fields are combined with a logical 'AND'. */
export type ReferencesBoolExp = {
  _and?: Array<ReferencesBoolExp> | null | undefined;
  _not?: ReferencesBoolExp | null | undefined;
  _or?: Array<ReferencesBoolExp> | null | undefined;
  authors?: StringArrayComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSourceReferences?: DataSourceReferencesBoolExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  documentUrl?: StringComparisonExp | null | undefined;
  edition?: StringComparisonExp | null | undefined;
  evidences?: EvidencesBoolExp | null | undefined;
  evidencesAggregate?: EvidencesAggregateBoolExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  isbn?: StringComparisonExp | null | undefined;
  publishedDate?: StringComparisonExp | null | undefined;
  referenceFiles?: ReferenceFilesBoolExp | null | undefined;
  referencePublishers?: ReferencePublishersBoolExp | null | undefined;
  seq?: IntComparisonExp | null | undefined;
  shortCode?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  title?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Ordering options when selecting data from "references". */
export type ReferencesOrderBy = {
  authors?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  dataSourceReferencesAggregate?: DataSourceReferencesAggregateOrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  documentUrl?: OrderBy | null | undefined;
  edition?: OrderBy | null | undefined;
  evidencesAggregate?: EvidencesAggregateOrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  isbn?: OrderBy | null | undefined;
  publishedDate?: OrderBy | null | undefined;
  referenceFilesAggregate?: ReferenceFilesAggregateOrderBy | null | undefined;
  referencePublishersAggregate?: ReferencePublishersAggregateOrderBy | null | undefined;
  seq?: OrderBy | null | undefined;
  shortCode?: OrderBy | null | undefined;
  tenant?: TenantsOrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  title?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "relation_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type RelationRecordComposerDefinitionsBoolExp = {
  _and?: Array<RelationRecordComposerDefinitionsBoolExp> | null | undefined;
  _not?: RelationRecordComposerDefinitionsBoolExp | null | undefined;
  _or?: Array<RelationRecordComposerDefinitionsBoolExp> | null | undefined;
  recordComposerDefinition?: RecordComposerDefinitionsBoolExp | null | undefined;
  recordComposerDefinitionId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "relation_records". All fields are combined with a logical 'AND'. */
export type RelationRecordsBoolExp = {
  _and?: Array<RelationRecordsBoolExp> | null | undefined;
  _not?: RelationRecordsBoolExp | null | undefined;
  _or?: Array<RelationRecordsBoolExp> | null | undefined;
  firstSourceRecordEdge?: SourceRecordEdgesBoolExp | null | undefined;
  firstTargetRecordEdge?: TargetRecordEdgesBoolExp | null | undefined;
  record?: RecordsBoolExp | null | undefined;
  recordId?: UuidComparisonExp | null | undefined;
  sourceRecordEdges?: SourceRecordEdgesBoolExp | null | undefined;
  targetRecordEdges?: TargetRecordEdgesBoolExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "relation_types". All fields are combined with a logical 'AND'. */
export type RelationTypesBoolExp = {
  _and?: Array<RelationTypesBoolExp> | null | undefined;
  _not?: RelationTypesBoolExp | null | undefined;
  _or?: Array<RelationTypesBoolExp> | null | undefined;
  categories?: CategoriesBoolExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  sourceCategory?: CategoriesBoolExp | null | undefined;
  sourceCategoryId?: UuidComparisonExp | null | undefined;
  targetCategory?: CategoriesBoolExp | null | undefined;
  targetCategoryId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type RolesBoolExp = {
  _and?: Array<RolesBoolExp> | null | undefined;
  _not?: RolesBoolExp | null | undefined;
  _or?: Array<RolesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userProductRoles?: UserProductRolesBoolExp | null | undefined;
};

/** Boolean expression to filter rows from the table "source_record_edges". All fields are combined with a logical 'AND'. */
export type SourceRecordEdgesBoolExp = {
  _and?: Array<SourceRecordEdgesBoolExp> | null | undefined;
  _not?: SourceRecordEdgesBoolExp | null | undefined;
  _or?: Array<SourceRecordEdgesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  entity?: RecordsBoolExp | null | undefined;
  entityRecord?: EntityRecordsBoolExp | null | undefined;
  entityRecordId?: UuidComparisonExp | null | undefined;
  relation?: RecordsBoolExp | null | undefined;
  relationRecord?: RelationRecordsBoolExp | null | undefined;
  relationRecordId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: Array<string> | null | undefined;
  /** does the array contain the given value */
  _contains?: Array<string> | null | undefined;
  _eq?: Array<string> | null | undefined;
  _gt?: Array<string> | null | undefined;
  _gte?: Array<string> | null | undefined;
  _in?: Array<Array<string>> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: Array<string> | null | undefined;
  _lte?: Array<string> | null | undefined;
  _neq?: Array<string> | null | undefined;
  _nin?: Array<Array<string>> | null | undefined;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  /** does the column match the given case-insensitive pattern */
  _ilike?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: string | null | undefined;
  _isNull?: boolean | null | undefined;
  /** does the column match the given pattern */
  _like?: string | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: string | null | undefined;
  /** does the column NOT match the given pattern */
  _nlike?: string | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: string | null | undefined;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: string | null | undefined;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: string | null | undefined;
  /** does the column match the given SQL regular expression */
  _similar?: string | null | undefined;
};

/** Boolean expression to filter rows from the table "target_record_edges". All fields are combined with a logical 'AND'. */
export type TargetRecordEdgesBoolExp = {
  _and?: Array<TargetRecordEdgesBoolExp> | null | undefined;
  _not?: TargetRecordEdgesBoolExp | null | undefined;
  _or?: Array<TargetRecordEdgesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  entity?: RecordsBoolExp | null | undefined;
  entityRecord?: EntityRecordsBoolExp | null | undefined;
  entityRecordId?: UuidComparisonExp | null | undefined;
  relation?: RecordsBoolExp | null | undefined;
  relationRecord?: RelationRecordsBoolExp | null | undefined;
  relationRecordId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
};

/** order by aggregate values of table "tenant_product_installations" */
export type TenantProductInstallationsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: TenantProductInstallationsMaxOrderBy | null | undefined;
  min?: TenantProductInstallationsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "tenant_product_installations". All fields are combined with a logical 'AND'. */
export type TenantProductInstallationsBoolExp = {
  _and?: Array<TenantProductInstallationsBoolExp> | null | undefined;
  _not?: TenantProductInstallationsBoolExp | null | undefined;
  _or?: Array<TenantProductInstallationsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  product?: ProductsBoolExp | null | undefined;
  productId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  visibility?: StringComparisonExp | null | undefined;
};

/** order by max() on columns of table "tenant_product_installations" */
export type TenantProductInstallationsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  productId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  visibility?: OrderBy | null | undefined;
};

/** order by min() on columns of table "tenant_product_installations" */
export type TenantProductInstallationsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  productId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  visibility?: OrderBy | null | undefined;
};

/** order by aggregate values of table "tenants" */
export type TenantsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: TenantsMaxOrderBy | null | undefined;
  min?: TenantsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type TenantsBoolExp = {
  _and?: Array<TenantsBoolExp> | null | undefined;
  _not?: TenantsBoolExp | null | undefined;
  _or?: Array<TenantsBoolExp> | null | undefined;
  allowAutoApproveChangeRequests?: BooleanComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  organization?: OrganizationsBoolExp | null | undefined;
  organizationId?: UuidComparisonExp | null | undefined;
  ownerUser?: UsersBoolExp | null | undefined;
  ownerUserId?: UuidComparisonExp | null | undefined;
  shortCode?: StringComparisonExp | null | undefined;
  tenantProductInstallations?: TenantProductInstallationsBoolExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userTenants?: UserTenantsBoolExp | null | undefined;
  userTenantsAggregate?: UserTenantsAggregateBoolExp | null | undefined;
};

/** order by max() on columns of table "tenants" */
export type TenantsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  organizationId?: OrderBy | null | undefined;
  ownerUserId?: OrderBy | null | undefined;
  shortCode?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** order by min() on columns of table "tenants" */
export type TenantsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  organizationId?: OrderBy | null | undefined;
  ownerUserId?: OrderBy | null | undefined;
  shortCode?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
};

/** Ordering options when selecting data from "tenants". */
export type TenantsOrderBy = {
  allowAutoApproveChangeRequests?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  name?: OrderBy | null | undefined;
  organization?: OrganizationsOrderBy | null | undefined;
  organizationId?: OrderBy | null | undefined;
  ownerUser?: UsersOrderBy | null | undefined;
  ownerUserId?: OrderBy | null | undefined;
  shortCode?: OrderBy | null | undefined;
  tenantProductInstallationsAggregate?: TenantProductInstallationsAggregateOrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userTenantsAggregate?: UserTenantsAggregateOrderBy | null | undefined;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

export type UnifiedEvidenceDraftsAggregateBoolExp = {
  count?: UnifiedEvidenceDraftsAggregateBoolExpCount | null | undefined;
};

/** order by aggregate values of table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: UnifiedEvidenceDraftsMaxOrderBy | null | undefined;
  min?: UnifiedEvidenceDraftsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "unified_evidence_drafts". All fields are combined with a logical 'AND'. */
export type UnifiedEvidenceDraftsBoolExp = {
  _and?: Array<UnifiedEvidenceDraftsBoolExp> | null | undefined;
  _not?: UnifiedEvidenceDraftsBoolExp | null | undefined;
  _or?: Array<UnifiedEvidenceDraftsBoolExp> | null | undefined;
  batchEvidencesJob?: BatchEvidencesJobsBoolExp | null | undefined;
  batchEvidencesJobId?: UuidComparisonExp | null | undefined;
  citation?: JsonbComparisonExp | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  dataSourceId?: UuidComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  evidenceId?: UuidComparisonExp | null | undefined;
  evidenceImporterId?: UuidComparisonExp | null | undefined;
  evidenceSetId?: UuidComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  metadata?: JsonbComparisonExp | null | undefined;
  parentEvidenceId?: UuidComparisonExp | null | undefined;
  parentEvidenceVersion?: EvidenceVersionsBoolExp | null | undefined;
  parentEvidenceVersionId?: UuidComparisonExp | null | undefined;
  properties?: JsonbComparisonExp | null | undefined;
  referenceId?: UuidComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
  wikipedia?: JsonbComparisonExp | null | undefined;
};

/** order by max() on columns of table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsMaxOrderBy = {
  batchEvidencesJobId?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidenceId?: OrderBy | null | undefined;
  evidenceImporterId?: OrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  parentEvidenceId?: OrderBy | null | undefined;
  parentEvidenceVersionId?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsMinOrderBy = {
  batchEvidencesJobId?: OrderBy | null | undefined;
  createdAt?: OrderBy | null | undefined;
  dataSourceId?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  evidenceId?: OrderBy | null | undefined;
  evidenceImporterId?: OrderBy | null | undefined;
  evidenceSetId?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  parentEvidenceId?: OrderBy | null | undefined;
  parentEvidenceVersionId?: OrderBy | null | undefined;
  referenceId?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** select columns of table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsSelectColumn =
  /** column name */
  | 'batchEvidencesJobId'
  /** column name */
  | 'citation'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dataSourceId'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'evidenceId'
  /** column name */
  | 'evidenceImporterId'
  /** column name */
  | 'evidenceSetId'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'parentEvidenceId'
  /** column name */
  | 'parentEvidenceVersionId'
  /** column name */
  | 'properties'
  /** column name */
  | 'referenceId'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'wikipedia';

/** Boolean expression to filter rows from the table "user_groups". All fields are combined with a logical 'AND'. */
export type UserGroupsBoolExp = {
  _and?: Array<UserGroupsBoolExp> | null | undefined;
  _not?: UserGroupsBoolExp | null | undefined;
  _or?: Array<UserGroupsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  description?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  users?: UserUserGroupsBoolExp | null | undefined;
};

/** order by aggregate values of table "user_product_roles" */
export type UserProductRolesAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: UserProductRolesMaxOrderBy | null | undefined;
  min?: UserProductRolesMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "user_product_roles". All fields are combined with a logical 'AND'. */
export type UserProductRolesBoolExp = {
  _and?: Array<UserProductRolesBoolExp> | null | undefined;
  _not?: UserProductRolesBoolExp | null | undefined;
  _or?: Array<UserProductRolesBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  product?: ProductsBoolExp | null | undefined;
  productId?: UuidComparisonExp | null | undefined;
  role?: RolesBoolExp | null | undefined;
  roleId?: UuidComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** order by max() on columns of table "user_product_roles" */
export type UserProductRolesMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  productId?: OrderBy | null | undefined;
  roleId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "user_product_roles" */
export type UserProductRolesMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  productId?: OrderBy | null | undefined;
  roleId?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "user_segments". All fields are combined with a logical 'AND'. */
export type UserSegmentsBoolExp = {
  _and?: Array<UserSegmentsBoolExp> | null | undefined;
  _not?: UserSegmentsBoolExp | null | undefined;
  _or?: Array<UserSegmentsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  id?: IntComparisonExp | null | undefined;
  name?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
};

export type UserTenantsAggregateBoolExp = {
  count?: UserTenantsAggregateBoolExpCount | null | undefined;
};

/** order by aggregate values of table "user_tenants" */
export type UserTenantsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: UserTenantsMaxOrderBy | null | undefined;
  min?: UserTenantsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "user_tenants". All fields are combined with a logical 'AND'. */
export type UserTenantsBoolExp = {
  _and?: Array<UserTenantsBoolExp> | null | undefined;
  _not?: UserTenantsBoolExp | null | undefined;
  _or?: Array<UserTenantsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  organization?: OrganizationsBoolExp | null | undefined;
  organizationId?: UuidComparisonExp | null | undefined;
  role?: StringComparisonExp | null | undefined;
  tenant?: TenantsBoolExp | null | undefined;
  tenantId?: UuidComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** order by max() on columns of table "user_tenants" */
export type UserTenantsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  organizationId?: OrderBy | null | undefined;
  role?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "user_tenants" */
export type UserTenantsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  organizationId?: OrderBy | null | undefined;
  role?: OrderBy | null | undefined;
  tenantId?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** select columns of table "user_tenants" */
export type UserTenantsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'role'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'userId';

/** order by aggregate values of table "user_user_groups" */
export type UserUserGroupsAggregateOrderBy = {
  count?: OrderBy | null | undefined;
  max?: UserUserGroupsMaxOrderBy | null | undefined;
  min?: UserUserGroupsMinOrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "user_user_groups". All fields are combined with a logical 'AND'. */
export type UserUserGroupsBoolExp = {
  _and?: Array<UserUserGroupsBoolExp> | null | undefined;
  _not?: UserUserGroupsBoolExp | null | undefined;
  _or?: Array<UserUserGroupsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  user?: UsersBoolExp | null | undefined;
  userGroup?: UserGroupsBoolExp | null | undefined;
  userGroupId?: UuidComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
};

/** order by max() on columns of table "user_user_groups" */
export type UserUserGroupsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  userGroupId?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "user_user_groups" */
export type UserUserGroupsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  userGroupId?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
};

/** order by aggregate values of table "user_user_segments" */
export type UserUserSegmentsAggregateOrderBy = {
  avg?: UserUserSegmentsAvgOrderBy | null | undefined;
  count?: OrderBy | null | undefined;
  max?: UserUserSegmentsMaxOrderBy | null | undefined;
  min?: UserUserSegmentsMinOrderBy | null | undefined;
  stddev?: UserUserSegmentsStddevOrderBy | null | undefined;
  stddevPop?: UserUserSegmentsStddevPopOrderBy | null | undefined;
  stddevSamp?: UserUserSegmentsStddevSampOrderBy | null | undefined;
  sum?: UserUserSegmentsSumOrderBy | null | undefined;
  varPop?: UserUserSegmentsVarPopOrderBy | null | undefined;
  varSamp?: UserUserSegmentsVarSampOrderBy | null | undefined;
  variance?: UserUserSegmentsVarianceOrderBy | null | undefined;
};

/** order by avg() on columns of table "user_user_segments" */
export type UserUserSegmentsAvgOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "user_user_segments". All fields are combined with a logical 'AND'. */
export type UserUserSegmentsBoolExp = {
  _and?: Array<UserUserSegmentsBoolExp> | null | undefined;
  _not?: UserUserSegmentsBoolExp | null | undefined;
  _or?: Array<UserUserSegmentsBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  userId?: UuidComparisonExp | null | undefined;
  userSegment?: UserSegmentsBoolExp | null | undefined;
  userSegmentId?: IntComparisonExp | null | undefined;
};

/** order by max() on columns of table "user_user_segments" */
export type UserUserSegmentsMaxOrderBy = {
  createdAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
  userSegmentId?: OrderBy | null | undefined;
};

/** order by min() on columns of table "user_user_segments" */
export type UserUserSegmentsMinOrderBy = {
  createdAt?: OrderBy | null | undefined;
  userId?: OrderBy | null | undefined;
  userSegmentId?: OrderBy | null | undefined;
};

/** order by stddev() on columns of table "user_user_segments" */
export type UserUserSegmentsStddevOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** order by stddevPop() on columns of table "user_user_segments" */
export type UserUserSegmentsStddevPopOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** order by stddevSamp() on columns of table "user_user_segments" */
export type UserUserSegmentsStddevSampOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** order by sum() on columns of table "user_user_segments" */
export type UserUserSegmentsSumOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** order by varPop() on columns of table "user_user_segments" */
export type UserUserSegmentsVarPopOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** order by varSamp() on columns of table "user_user_segments" */
export type UserUserSegmentsVarSampOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** order by variance() on columns of table "user_user_segments" */
export type UserUserSegmentsVarianceOrderBy = {
  userSegmentId?: OrderBy | null | undefined;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: Array<UsersBoolExp> | null | undefined;
  _not?: UsersBoolExp | null | undefined;
  _or?: Array<UsersBoolExp> | null | undefined;
  createdAt?: TimestamptzComparisonExp | null | undefined;
  deactivatedAt?: TimestamptzComparisonExp | null | undefined;
  displayName?: StringComparisonExp | null | undefined;
  email?: StringComparisonExp | null | undefined;
  id?: UuidComparisonExp | null | undefined;
  memo?: StringComparisonExp | null | undefined;
  organization?: OrganizationsBoolExp | null | undefined;
  organizationId?: UuidComparisonExp | null | undefined;
  photoUrl?: StringComparisonExp | null | undefined;
  updatedAt?: TimestamptzComparisonExp | null | undefined;
  userProductRoles?: UserProductRolesBoolExp | null | undefined;
  userTenants?: UserTenantsBoolExp | null | undefined;
  userTenantsAggregate?: UserTenantsAggregateBoolExp | null | undefined;
  userUserGroups?: UserUserGroupsBoolExp | null | undefined;
  userUserSegments?: UserUserSegmentsBoolExp | null | undefined;
};

/** Ordering options when selecting data from "users". */
export type UsersOrderBy = {
  createdAt?: OrderBy | null | undefined;
  deactivatedAt?: OrderBy | null | undefined;
  displayName?: OrderBy | null | undefined;
  email?: OrderBy | null | undefined;
  id?: OrderBy | null | undefined;
  memo?: OrderBy | null | undefined;
  organization?: OrganizationsOrderBy | null | undefined;
  organizationId?: OrderBy | null | undefined;
  photoUrl?: OrderBy | null | undefined;
  updatedAt?: OrderBy | null | undefined;
  userProductRolesAggregate?: UserProductRolesAggregateOrderBy | null | undefined;
  userTenantsAggregate?: UserTenantsAggregateOrderBy | null | undefined;
  userUserGroupsAggregate?: UserUserGroupsAggregateOrderBy | null | undefined;
  userUserSegmentsAggregate?: UserUserSegmentsAggregateOrderBy | null | undefined;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: Array<string> | null | undefined;
  /** does the array contain the given value */
  _contains?: Array<string> | null | undefined;
  _eq?: Array<string> | null | undefined;
  _gt?: Array<string> | null | undefined;
  _gte?: Array<string> | null | undefined;
  _in?: Array<Array<string>> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: Array<string> | null | undefined;
  _lte?: Array<string> | null | undefined;
  _neq?: Array<string> | null | undefined;
  _nin?: Array<Array<string>> | null | undefined;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _isNull?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

export type BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExpCount = {
  arguments?: Array<BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: BatchChangeRequestsJobRecordComposerDefinitionsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type BatchEvidencesJobsAggregateBoolExpCount = {
  arguments?: Array<BatchEvidencesJobsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: BatchEvidencesJobsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ChangeRequestItemsAggregateBoolExpCount = {
  arguments?: Array<ChangeRequestItemsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ChangeRequestItemsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ChangeRequestRecordComposerDefinitionsAggregateBoolExpCount = {
  arguments?: Array<ChangeRequestRecordComposerDefinitionsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ChangeRequestRecordComposerDefinitionsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ChangeRequestReviewsAggregateBoolExpCount = {
  arguments?: Array<ChangeRequestReviewsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ChangeRequestReviewsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type ChangeRequestsAggregateBoolExpCount = {
  arguments?: Array<ChangeRequestsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: ChangeRequestsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type EvidenceEvidenceSetsAggregateBoolExpCount = {
  arguments?: Array<EvidenceEvidenceSetsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: EvidenceEvidenceSetsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type EvidencesAggregateBoolExpCount = {
  arguments?: Array<EvidencesSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: EvidencesBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type RecordGeoItemsAggregateBoolExpCount = {
  arguments?: Array<RecordGeoItemsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: RecordGeoItemsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type UnifiedEvidenceDraftsAggregateBoolExpCount = {
  arguments?: Array<UnifiedEvidenceDraftsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: UnifiedEvidenceDraftsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type UserTenantsAggregateBoolExpCount = {
  arguments?: Array<UserTenantsSelectColumn> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: UserTenantsBoolExp | null | undefined;
  predicate: IntComparisonExp;
};

export type GetEvidencesQueryVariables = Exact<{
  tenantId: string;
  limit: number;
  offset?: number;
  where?: Types.EvidencesBoolExp | null | undefined;
  order_by: Types.EvidencesOrderBy;
}>;


export type GetEvidencesQuery = { evidences: Array<{ __typename: 'Evidences', id: string, properties: Types.JsonObject, metadata: Types.JsonObject, updatedAt: string, deactivatedAt: string | null, user: { __typename: 'Users', displayName: string | null, email: string }, reference: { __typename: 'References', shortCode: string, title: string } }> };


export const GetEvidencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEvidences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EvidencesBoolExp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EvidencesOrderBy"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evidences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"where"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"properties"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortCode"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}}]}}]}}]} as unknown as DocumentNode<GetEvidencesQuery, GetEvidencesQueryVariables>;